var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFileIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.73,
    height: 21.354,
    viewBox: "0 0 20.73 21.354",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4766",
    "data-name": "Group 4766"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    d: "M3,12.3v7.284a2.081,2.081,0,0,0,2.081,2.081H19.649a2.081,2.081,0,0,0,2.081-2.081V12.3",
    transform: "translate(-3 -2.311)",
    fill: "none",
    stroke: "#1450FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4765",
    "data-name": "Group 4765",
    transform: "translate(5.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Right",
    d: "M7.9,6.862,12.166,2.7l4.266,4.162",
    transform: "translate(-7.9 -2.7)",
    fill: "none",
    stroke: "#1450FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_175",
    "data-name": "Line 175",
    y1: 11.966,
    transform: "translate(4.266 2.185)",
    fill: "none",
    stroke: "#1450FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileIconBlue);
export default __webpack_public_path__ + "static/media/upload-file-icon-blue.615ec39e0f72530c30aae40b6a1a4485.svg";
export { ForwardRef as ReactComponent };